<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <g clip-path="url(#clip0_349_24629)">
          <path
            d="M11.2433 22.4739C11.4163 22.6025 11.5892 22.6668 11.7622 22.6668C11.9352 22.6668 12.1082 22.6025 12.2811 22.4739L20.8145 17.0054C21.1027 16.8124 21.3334 16.4263 21.3334 
              15.976C21.3334 15.5257 21.1604 15.1397 20.8145 14.9467L12.2811 9.47825C11.9352 9.28524 11.5316 9.28524 11.1856 9.47825C10.8973 9.6713 10.6667 10.0572 10.6667 10.5076V21.4444C10.6667 
              21.8948 10.8973 22.2808 11.2433 22.4739Z"
            fill="white"
          />
          <path
            d="M1.28275 3.64676C1.35734 3.38537 1.56755 3.18773 1.84556 3.1176C2.12358 3.04747 2.40837 3.1176 2.6118 3.30886L3.51365 4.1568L3.75098 3.95916C6.95832 1.31334 10.9726 
              0 14.9733 0C19.3469 0 23.7138 1.56836 27.0229 4.67958C30.2302 7.69517 32 11.7181 32 15.996C32 20.2803 30.2302 24.2969 27.0229 27.3188C20.3844 33.5604 9.58251 33.5604 
              2.94406 27.3188C2.72029 27.1084 2.59824 26.8343 2.59824 26.541C2.59824 26.2477 2.72029 25.9736 2.94406 25.7632C3.39838 25.3361 4.14427 25.3361 4.59859 25.7632C7.36517 
              28.3644 11.054 29.7989 14.9868 29.7989C18.913 29.7989 22.6017 28.3644 25.3751 25.7632C31.1049 20.376 31.1049 11.6161 25.3751 6.23519C22.7374 3.76152 19.2452 2.33342 
              15.5225 2.20591C11.8202 2.0784 8.24668 3.24511 5.44619 5.49564L5.16818 5.71878L6.04969 6.54759C6.25311 6.73886 6.3277 7.00662 6.25311 7.26802C6.17852 7.52941 5.96832 
              7.72705 5.6903 7.79718L0.997958 8.98301C0.719943 9.05314 0.435148 8.98301 0.231723 8.79175C0.0282973 8.60049 -0.0462921 8.33272 0.0282973 8.07133L1.28275 3.64676Z" 
            fill="white" 
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_349_24629">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
  </svg>
</template>
